import { Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from "@mui/material";
import axios, { AxiosResponse } from "axios";
import React, { useEffect, useState } from "react";
import FilterColumnsType from '../../Interfaces/FilterColumnsInterface';
import GridInterface from "../../Interfaces/GridInterface";
import PaginationType from "../../Interfaces/PaginationInterface";
import { baseOcelotUrl } from "../../Utils/BaseAPI";
import { FieldExtractor } from "../../Utils/field-extractor";
import './UserPage.css';
import { UserType } from "./Interfaces/UserType";
import grid from "./grid";

const UserPage = (props: any) => {


    const [dataArr, updateArr] = useState<UserType[]>([]);
    const [selectedIds, updateSelectedIds] = useState<string[]>([]);
    const [parentViewModel, updateParentViewModel] = useState<any>();
    const [filterColumns, updateFilterColumns] = useState<FilterColumnsType[]>([]);

    type Order = 'asc' | 'desc';

    const [order, setOrder] = React.useState<Order>('asc');
    const [orderBy, setOrderBy] = React.useState<keyof GridInterface>('name');
    const [filter, setFilter] = useState<string>();
    const [page, setPage] = React.useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);


    // const [filter, setFilter] = useState('');
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState<PaginationType>();
    const [columns, setColumns] = useState([]);
    const [selected, setSelected] = useState([]);
    const [rows, setRows] = useState<object[]>([]);
    const [onRequest, setOnRequest] = useState<Function>();
    // const [filterColumns, setFilterColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState<string[]>([]);
    const [uomList, setUomList] = useState([]);

    useEffect(() => {
        setFilter(filter);
        setLoading(loading);
        setPagination(pagination);
        setSelected(selected);
        setRows(rows);
        setOnRequest(onRequest);
        updateFilterColumns(filterColumns);
        setVisibleColumns(visibleColumns);
        setUomList(uomList);

        window.removeEventListener('message', messageCallBack);
        window.addEventListener("message", messageCallBack, false);
        // updateGrid();
        grid.forEach((el: GridInterface) => {
            filterColumns.push({
                columnName: el.name,
                columnSearchValue: null,
                columnVisible: el.visible,
                columnSearchable: el.searchable
            })
        });
    }, []);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const messageCallBack = (e: any) => {
        const urls = process.env.REACT_APP_ALLOWED_URLS?.split(',');
        if (urls?.includes(e.origin)) {
            if (e?.data && e?.data?.type == 'updateViewModel') {
                updateParentViewModel(e.data.viewModel);
            }
        }
    }

    const updateGrid = () => {
        let checkFilter = (el: FilterColumnsType) => el.columnSearchValue != null;
        if (filterColumns.some(checkFilter) && page > 1) {
            setPage(1);
        }

        axios.get(baseOcelotUrl + 'api/hub/GetOnlineUsers')
            .then((result: AxiosResponse) => {
                if (result && result.data) {
                    let resultForMapping = FieldExtractor.extractArrayObjectField(result.data.ClientList, '', null, true) as UserType[];
                    updateArr(resultForMapping);
                }
            })
    };

    useEffect(() => {
        updateGrid();
    }, [filter])

    const createSortHandler = (property: keyof GridInterface) => (event: React.MouseEvent<unknown>) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const selectAllClick = (e: React.ChangeEvent<HTMLInputElement>) => {
        let bool = e.target.checked;
        if (bool) {
            let allIds = dataArr?.map((el) => {
                return el.id;
            })
            if (allIds && allIds.length > 0) {
                updateSelectedIds(allIds);
            }
        } else {
            updateSelectedIds([]);
        }
    };

    const updateSelectedIdsFun = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
        let updatedIds = [...selectedIds];
        if (e.target.checked) {
            updatedIds.push(id);
        } else {
            updatedIds = updatedIds.filter((selectedId) => selectedId !== id);
        }
        updateSelectedIds(updatedIds);
    };

    return (
        <React.Fragment>
                    <div className="mt-10 mb-10 inline-flex items-center justify-center gap-10">
                        <Button variant="contained" onClick={updateGrid} color="info">Ricarica</Button>
                    </div>
                    <div className="global-filter">
                        <input type="text" value={filter} placeholder=" Cerca..."></input>
                    </div>
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table" className="table-center">
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                color="primary"
                                                onChange={selectAllClick}
                                                indeterminate={selectedIds.length > 0 && selectedIds.length < dataArr.length}
                                                checked={dataArr!.length > 0 && selectedIds.length === dataArr.length}
                                                inputProps={{
                                                    'aria-label': 'select all',
                                                }}
                                            />
                                        </TableCell>
                                        {grid.map((el, index) => {
                                            // return <TableCell key={index}>{el.label}</TableCell>
                                            return (
                                                <TableCell
                                                    key={el.name}
                                                    sortDirection={orderBy === el.name ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === el.name}
                                                        direction={orderBy === el.name ? order : 'asc'}
                                                        onClick={createSortHandler(el.name as keyof GridInterface)}
                                                    >
                                                        {el.label}
                                                    </TableSortLabel>
                                                </TableCell>)
                                        })}
                                    </TableRow>
                                    
                                </TableHead>
                                <TableBody id="boxes-table">
                                    {dataArr?.map((item) => {
                                        const isItemSelected = selectedIds.includes(item.id);
                                        // const { clicked, setClicked, points, setPoints } = useContextMenu();
                                        return (
                                            <TableRow
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                selected={isItemSelected}
                                                key={item?.id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell><input type="checkbox" checked={isItemSelected} onChange={(e) => { updateSelectedIdsFun(e, item?.id) }}></input></TableCell>
                                                <TableCell>{item?.id}</TableCell>
                                                <TableCell>{item?.name}</TableCell>
                                                <TableCell>{item?.tenantName}</TableCell>
                                                <TableCell>{item?.tenantId}</TableCell>
                                                <TableCell>{item?.webPage}</TableCell>
                                            </TableRow>);
                                    })}
                                </TableBody>
                            </Table>

                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100, { label: 'Tutti', value: -1 }]}
                                component="div"
                                count={dataArr?.length || 0}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />

                        </TableContainer>

                    </Paper>
                </React.Fragment>
    );
};

export default UserPage;